import { render, staticRenderFns } from "./FileMetadata.vue?vue&type=template&id=fd0df972&"
import script from "./FileMetadata.vue?vue&type=script&lang=js&"
export * from "./FileMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports